var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ui-DetailButton"},[_c('div',{class:{
      typeA: _vm.type === 'A',
      typeB: _vm.type === 'B',
      typeC: _vm.type === 'C',
    }},[_c('div',{staticClass:"cover"},[_c('router-link',{attrs:{"to":`${_vm.path}`}},[_c('div',{staticClass:"button"},[_c('div',{staticClass:"arrow-before"}),_c('p',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"arrow"})])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }